export const GRAPHQL_VARIABLES = {
  lat: 'String!',
  lng: 'String!'
};

export const QUERY = `
 mutation updateMicrosite($lat: String!, $lng: String!) {
   updateMicrosite(lat: $lat, lng: $lng) {
       message
   }
 }
 `;
